import React from 'react';
import cn from 'classnames';
import Toggle from '../../../ui/Toggle';

type Props = {
  on: boolean
  active: boolean
  handleStateSwitch: (state: boolean) => void
}

export default function RequiredToggle({on, active, handleStateSwitch}: Props) {

  return (
    <>
      <Toggle on={on} active={active} handleStateSwitch={handleStateSwitch}/>
      <span className={cn('ml-2 py-0.5', {
        'text-red': on,
        'text-gray-dark': !on,
        'text-opacity-40': !active
      })}>Required</span>
    </>
  );
}
